import { Bridge, type Options } from '@zoom/hybrid-jsbridge';
import { PostMessageOption } from '../types';
import type { Response } from '../utils/type';

export function postJsMessage<T, R>(
  functionName: string,
  params: T,
  options?: PostMessageOption
): Response<R> {
  return Bridge.getInstance().postJsMessage<T, R>({
    functionName,
    params,
    ...options,
  }) as Response<R>;
}

export function clearJsCallTimer(jsCallId: string) {
  return Bridge.getInstance().clearTimeHandler(jsCallId);
}

export function getBridgeOptions(): Options {
  return Bridge.getInstance().getBridgeOptions();
}

export function postAppBridgeMessage<T, R>(
  apiName: string,
  data: T,
  options?: PostMessageOption
): Response<R> {
  return Bridge.getInstance().postJsMessage<T, R>({
    apiName,
    data,
    ...options,
  }) as Response<R>;
}

export function registerSpecificNotificationHandler(
  notifications: string | string[],
  handler: (message: any) => void
) {
  Bridge.getInstance().registerSpecificNotificationHandler(
    notifications,
    handler
  );
}

export function unregisterSpecificNotificationHandler(
  notifications: string | string[],
  handler: ((message: any) => void) | undefined
) {
  Bridge.getInstance().unregisterSpecificNotificationHandler(
    notifications,
    handler
  );
}

export function registerNotificationHandler(handler: (message: any) => void) {
  Bridge.getInstance().registerNotificationHandler(handler);
}

export function unregisterNotificationHandler(handler: (message: any) => void) {
  Bridge.getInstance().unregisterNotificationHandler(handler);
}
